<div class="modal-header">
  <h5 class="modal-title mb-0 sd-text-primary">Menu List </h5>
  <button type="button" class="btn-close custom-close-btn" aria-label="Close" (click)="closeModal()"></button>
</div>

<div class="modal-body bg-light">
  <div class="card shadow-sm border-0">
    <div class="card-body text-center">
      <h5 class="sd-text-primary mb-4">Try these menus options:</h5>

      <div class="d-flex flex-wrap justify-content-center gap-2">
        <button *ngFor="let menu of filteredMenus" type="button" name="menu"
          class="btn btn-outline-info rounded-pill px-3 py-2 fs-5" (click)="navigate(menu)">
          <i class="fa fa-long-arrow-right" aria-hidden="true"></i> Main Menu - {{ menu.title }}
        </button>
      </div>

      <ng-container *ngFor="let menu of filteredMenus">
        <div *ngIf="menu.submenu?.length" class="mt-4">
          <div class="d-flex flex-wrap justify-content-center gap-2">
            <button *ngFor="let sub of menu.submenu" type="button" name="submenu"
              class="btn btn-outline-info rounded-pill px-3 py-2" (click)="navigate(sub)">
              <i class="fa fa-long-arrow-right" aria-hidden="true"></i> Sub Menu - {{ sub.title }}
            </button>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>